import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

// import Courses from "./Courses";
import Section from "./Section";

import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import ServicesDetail from "./ServicesDetail";
import RevenueLineChart from "./RevenueLineChart";
import OnlineLocations from "./OnlineLocations";
import Loader from "../../../Components/Common/Loader";
import WidgetAdmin from "./WidgetAdmin";
import WidgetOrganisateur from "./Organisateur/WidgetOrganisateur";
import RevenueTicketLineChart from "./Organisateur/RevenueLineChart";
import { lireRoleSession } from "../../../espace";

const DashboardAdmin = ( props ) =>
{
  const [ loading, setLoading ] = useState( true )

  const [ roleSession, setRoleSession ] = useState( lireRoleSession )

  // Période choisie dans l'en-tête. Le mois courant par défaut : le sélecteur
  // affichait jusqu'ici une date en dur héritée du gabarit, sans rien filtrer.
  const debutDuMois = new Date();
  debutDuMois.setDate( 1 );

  const [ periode, setPeriode ] = useState( {
    debut: debutDuMois,
    fin: new Date(),
  } );
  function getSessionData ()
  {
    if ( localStorage.getItem( "authUser" ) )
    {
      const obj = JSON.parse( localStorage.getItem( "authUser" ) );
      // console.log( 'obj localStorage:', obj )
      setRoleSession( obj.role )
    }
    setLoading( false )
  }

  useEffect( () =>
  {
    getSessionData()
  }, [] )

  document.title = `${ props.t( "Dashboard" ) } | Takci - ${ roleSession === "ORGANISATEUR" ? "Organisateur" : "Admin" }`;

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title={ props.t( "Dashboard" ) }
            pageTitle={ props.t( "Dashboards" ) }
          />

          {
            loading ?
              <Row>
                <Loader />
              </Row>
              :
              <Row g={ 2 } className="">
                <Col>
                  <div className="h-100 mb-2">
                    <Section periode={ periode } onPeriodeChange={ setPeriode } />
                    <Row g={ 2 } className="g-3">
                      {
                        roleSession === "ORGANISATEUR" ? <WidgetOrganisateur /> : <WidgetAdmin periode={ periode } />
                      }
                      {
                        roleSession === "ORGANISATEUR" ?
                          <RevenueTicketLineChart /> :
                          <RevenueLineChart />
                      }
                    </Row>

                    {
                      roleSession !== "ORGANISATEUR" &&
                      <>
                        <Row g={ 2 } className="g-3">
                          <ServicesDetail periode={ periode } />
                        </Row>
                        <Row g={ 2 } className="g-3">
                          <OnlineLocations />
                        </Row>
                      </>
                    }
                  </div>
                </Col>
              </Row>
          }
        </Container>
      </div>
    </React.Fragment>
  );
};

DashboardAdmin.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter( withTranslation()( DashboardAdmin ) );
